import { ButtonProps } from "../../../../types"
import { cn } from "../../../utils"
import Button from "../button"

const PrimaryBtn = ({ children, className, ...rest }: ButtonProps) => (
  <Button
    {...rest}
    className={cn(
      "border-transparent text-white bg-primary-400 hover:bg-primary-500 focus:ring-primary-300 disabled:opacity-40",
      className
    )}
  >
    {children}
  </Button>
)

export default PrimaryBtn
